import { IssueTile } from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/IssueTile';
import StandingTable from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable';
import SelectedPeriodTag from '@/creditflowresearch/ui/components/league/Scorecard/SelectedPeriodTag';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

import styles from '@/creditflowresearch/ui/components/league/Scorecard/scorecard.module.scss';

interface IScorecardContentProps {
  isScorecardTableFetching: boolean,
  isStandingInitialized: boolean,
  refCallback: (el: HTMLElement) => void,
}

const ScorecardContent = ({
  isScorecardTableFetching,
  isStandingInitialized,
  refCallback,
}: IScorecardContentProps) => {
  const { state } = useScorecardContext();
  const hasData = state.data?.categories && state.data.categories.length > 0;
  const shouldShowTable = isStandingInitialized || hasData;

  return (
    <>
      <div className={ styles.standingTableContainer } data-test="scorecardTableContainer">
        <Spinner isVisible={ isScorecardTableFetching } overlay />
        { shouldShowTable && <StandingTable /> }
      </div>
      <IssueTile
        ref={ refCallback }
        showDealStatusFilters={ false }
        titleToolbar={ <SelectedPeriodTag /> }
      />
    </>
  );
};

export default ScorecardContent;
